import { useIntervalFn } from "@vueuse/core";
import { readonly } from "vue";

type Options = {
  text: string;
  speed?: number;
};

export function useTypewriter(options: Options) {
  const config = {
    speed: 50,
    ...options,
  };

  const text = ref("");
  let index = 0;

  const textLength = config.text.length;

  const { pause, resume, isActive } = useIntervalFn(() => {
    if (index < textLength) {
      text.value += config.text[index];
      index++;
    } else {
      pause();
    }
  }, config.speed);

  resume();

  return {
    text: readonly(text),
    pause,
    resume,
    isActive: readonly(isActive),
  };
}
